module.exports = __webpack_public_path__ + "static/media/justcompare.f9c0d597.png";